<template>
  <v-dialog v-model="open" width="630px" scrollable>
    <v-card flat class="DrmModalGroup">
      <v-toolbar elevation="0">
        <v-tabs fixed-tabs ref="tabs">
          <v-tab
            v-for="(item, index) in configTabs"
            :key="item.tab"
            ref="tab"
            @click="handleTabChange(index)"
          >
            {{ item.tab }}
          </v-tab>
        </v-tabs>
      </v-toolbar>
      <div>
        <v-card-text
          style="height: 63vh"
          class="pl-7 pr-5 py-0"
          v-click-outside="handleExecuteChieldFunction"
        >
          <unsaved-changes-modal />
          <drm-main-settings
            :handleCloseModal="handleClose"
            :drmGroup="drmGroup"
            v-show="configTab === 0"
            :chieldFunction="chieldFunction"
            :chieldCleanFunction="chieldCleanFunction"
          />
          <drm-screen-time
            :handleCloseModal="handleClose"
            :drmGroup="drmGroup"
            v-if="configTab === 1"
            :chieldFunction="chieldFunction"
            :chieldCleanFunction="chieldCleanFunction"
          />
          <drm-settings-style
            :handleCloseModal="handleClose"
            :drmGroup="drmGroup"
            v-if="configTab === 2"
            :chieldFunction="chieldFunction"
            :chieldCleanFunction="chieldCleanFunction"
          />
          <drm-advanced
            :handleCloseModal="handleClose"
            :drmGroup="drmGroup"
            v-if="configTab === 3"
            :chieldFunction="chieldFunction"
            :chieldCleanFunction="chieldCleanFunction"
          />
        </v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import DrmMainSettings from './DrmMainSettings'
import DrmScreenTime from './DrmScreenTime'
import DrmSettingsStyle from './DrmSettingsStyle.vue'
import DrmAdvanced from './DrmAdvanced.vue'
import i18n from '@/translations/lang'
import UnsavedChangesModal from '@/components/UnsavedChangesModal.vue'

export default {
  name: 'DrmModalGroupSettings',
  components: {
    DrmMainSettings,
    DrmScreenTime,
    DrmSettingsStyle,
    DrmAdvanced,
    UnsavedChangesModal,
  },
  props: {
    drmGroup: Object,
  },
  data: () => ({
    open: false,
    isFetching: false,
    drmValue: false,
    configTab: 0,
    configTabs: [],
    chieldFunction: [],
    chieldCleanFunction: [],
    screenObjects: [],
    isChangeTab: false,
    indexTab: 0,
    oldConfigTab: 0,
  }),
  watch: {},
  mounted() {
    this.configTabs = [
      { tab: i18n.t('message.pages.drm.settings.tab1') },
      { tab: i18n.t('message.pages.drm.settings.tab2') },
      { tab: i18n.t('message.pages.drm.settings.tab3') },
      { tab: i18n.t('message.pages.drm.settings.tab4') },
    ]
    this.$root.$on('openDrmModalGroupSettings', (configTab) => {
      this.$root.$emit('resetDrmMainSettings')
      this.screenObjects = []
      Object.assign(this.$data, this.initialState())
      this.open = true
      if (configTab) {
        this.configTab = configTab
        this.oldConfigTab = configTab
      }
      if (configTab === 0) {
        const element = document.querySelectorAll(
          'div[role="tab"][tabindex="0"]'
        )
        element.forEach((el, index) => {
          el.ariaSelected = index === 0 ? 'true' : 'false'
          el.className = index === 0 ? 'v-tab v-tab--active' : 'v-tab'
        })
        this.oldConfigTab = configTab
        this.handleChangeSelectedTab(0)
      }
    })
    this.$root.$on('handleCloseDRM', () => {
      this.handleClose()
    })
    this.$root.$on('handleEditDrmTab', async (index) => {
      if (this.chieldCleanFunction.length > 0) {
        this.chieldCleanFunction.forEach((cleanFunction) => {
          if (typeof cleanFunction === 'function') cleanFunction()
        })
      }
      const oldIndex = this.configTab
      await this.handleTabChange(index)
      this.handleChangeElementSelection(index, oldIndex)
    })
  },
  beforeDestroy() {
    this.$root.$off('openDrmModalGroupSettings')
    this.$root.$off('handleCloseDRM')
  },
  methods: {
    handleClose() {
      this.chieldFunction = []
      this.open = false
      this.configTab = 0
      this.isChangeTab = false
      const selectedItemsLentgh =
        this.$refs?.tabs?.$refs?.items?.selectedItems.length
      if (selectedItemsLentgh > 0) {
        for (let i = 0; i < selectedItemsLentgh.length; i++) {
          this.$refs?.tabs?.$refs?.items?.selectedItems.pop()
        }
      }
      this.screenObjects = []
    },
    initialState() {
      return {
        open: false,
        isFetching: false,
        drmValue: false,
        configTab: 0,
        configTabs: [
          { tab: i18n.t('message.pages.drm.settings.tab1') },
          { tab: i18n.t('message.pages.drm.settings.tab2') },
          { tab: i18n.t('message.pages.drm.settings.tab3') },
          { tab: i18n.t('message.pages.drm.settings.tab4') },
        ],
        drmGroup: null,
      }
    },
    async handleExecuteChieldFunction(event) {
      if (!this.open) return

      this.handleSelectTab()
      const modal = document.querySelector('[class~="DrmModalGroup"]')
      if (
        modal.contains(document.activeElement) &&
        !document
          .querySelector('[class~="unsavedChanges"]')
          ?.contains(event.target)
      )
        return

      const modalWidth = modal?.offsetWidth
      const modalHeight = modal?.offsetHeight
      const modalLeft = modal?.getBoundingClientRect().left
      const modalTop = modal?.getBoundingClientRect().top

      const isClickInsideModal =
        event.clientX >= modalLeft &&
        event.clientX <= modalLeft + modalWidth &&
        event.clientY >= modalTop &&
        event.clientY <= modalTop + modalHeight

      if (isClickInsideModal) return
      this.checkChange()
    },
    checkChange(index) {
      if (this.chieldFunction.length > 0) {
        const validation = []
        let isChanged = false
        this.chieldFunction.forEach((fun) => {
          if (typeof fun === 'function') validation.push(fun())
          if (validation.includes(true)) {
            this.$root.$emit(
              'unsavedChangesModal',
              false,
              false,
              false,
              false,
              true,
              index
            )
            isChanged = true
          }
        })
        return isChanged
      }
    },
    handleTabChange(index) {
      if (index === this.configTab) return
      this.$nextTick(() => {
        const elements = this.$refs.tab
        if (this.checkChange(index)) {
          const actualElement = elements[this.configTab]
          this.$refs?.tabs?.$refs?.items?.selectedItems.splice(
            0,
            0,
            actualElement
          )
          this.isChangeTab = true
          this.indexTab = this.configTab
        } else {
          this.configTab = index
          this.isChangeTab = false
          this.handleChangeSelectedTab(index)
          this.handleChangeElementSelection(index, this.oldConfigTab)
        }
        this.oldConfigTab = index
      })
    },
    handleSelectTab() {
      if (this.isChangeTab) {
        const element = document.querySelectorAll(
          'div[role="tab"][tabindex="0"]'
        )
        element[this.indexTab].ariaSelected = 'true'
        element[this.indexTab].className = 'v-tab v-tab--active'

        element[this.oldConfigTab].ariaSelected = 'false'
        element[this.oldConfigTab].className = 'v-tab'

        this.isChangeTab = false
      }
    },
    handleChangeSelectedTab(index) {
      if (
        this.$refs &&
        this.$refs.tabs &&
        this.$refs.tabs.$refs &&
        this.$refs.tabs.$refs.items
      ) {
        this.$refs.tabs.$refs.items.selectedItems.splice(
          0,
          0,
          this.$refs.tab[index]
        )
        this.$refs.tabs.callSlider()
      }
    },
    handleChangeElementSelection(index, oldIndex) {
      const element = document.querySelectorAll('div[role="tab"][tabindex="0"]')
      element[index].ariaSelected = 'true'
      element[index].className = 'v-tab v-tab--active'

      element[oldIndex].ariaSelected = 'false'
      element[oldIndex].className = 'v-tab'
    },
  },
}
</script>

<style lang="scss">
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
.v-dialog .v-sheet.v-card {
  overflow: visible !important;
}
.v-dialog:not(.v-dialog--fullscreen) {
  background-color: var(--v-neutral-lighten4) !important;
}
.bg-dark {
  .v-dialog:not(.v-dialog--fullscreen) {
    background-color: var(--v-neutral-darken2) !important;
  }
}
</style>
